import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import SelectCity from "./selectCity";
import { Button } from "antd";
import { Link } from "react-router-dom";

const locationDetail = () => {
  return (
    <Row>
      <Col>
        <div className="location-detail">
          <div className="title"> Location Details </div>
          <div className="location-content">
            <div className="info">
              <p>Please share your current city for optimized experience</p>
            </div>

            <div className="user-content">
              <div className="mail-info">
                <div className="label-account d-flex align-items-center">City</div>
                <div className="acc-inp-cont">
                      <SelectCity />
                </div>
              </div>
             
            </div>
            {/* <div className="city-info">
              <div className="city-name" >City</div>
              <div ><SelectCity /></div>
            </div> */}
  
          </div>

          <div className=" update ">
          <Link to="/">
            <Button className="update-btn px-4">
             Save & Continue
            </Button>
            </Link>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default locationDetail;
